// @flow
import React, { Component } from 'react';
import payform from 'payform';

type Props = {
    input: Object,
    meta: Object,
    active: boolean,
    primaryColor: string,
    handleFocus: Function,
};

export default class CvcInput extends Component<Props> {
    cvc: Object;

    componentDidMount() {
        payform.cvcInput(this.cvc);
    }

    render() {
        const {
            input,
            meta: { touched, error, active },
        } = this.props;

        let isFieldInvalid = touched && error && !active;

        let focusColor = '#d7dde5';
        let iconColor = '#d7dde5';
        if (this.props.active) {
            focusColor = this.props.primaryColor
                ? this.props.primaryColor
                : '#00aae6';
        }

        if (this.props.active || this.cvc) {
            iconColor = this.props.primaryColor
                ? this.props.primaryColor
                : '#00aae6';
        }

        if (isFieldInvalid) {
            iconColor = '#f26f59';
        }

        /* BORDER BOTTOM COLOR */
        let borderBottom = `1px solid ${focusColor}`;
        if (isFieldInvalid) {
            borderBottom = `1px solid #f26f59`;
        }
        let className = isFieldInvalid ? 'invalid' : '';

        return (
            <div className="half">
                <input
                    {...input}
                    ref={ref => (this.cvc = ref)}
                    id="cvc"
                    placeholder=" "
                    type="text"
                    name="cvc"
                    required
                    className={className}
                    autoComplete="off"
                    maxLength="4"
                    onFocus={e => {
                        this.props.handleFocus(e);
                        input.onFocus(e);
                    }}
                    onBlur={e => {
                        this.props.handleFocus(e);
                        input.onBlur(e);
                    }}
                    style={{ borderBottom }}
                />
                <i className="ipic_card-back" style={{ color: iconColor }} />
                <label htmlFor="cvc">CVC</label>
                {touched &&
                    error &&
                    !active && (
                        <span className="validation-error">{error}</span>
                    )}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/ui/components/Inputs/CvcInput.js